import { handleActions } from 'redux-actions';
import { KEYWORDS, DAYINDEX } from '../actionTypes';
import { control } from '../initialState';

export default handleActions(
  {
    [KEYWORDS]: (state, action) => {
      return {
        ...state,
        keywords: action.payload
      };
    },
    [DAYINDEX]: (state, action) => {
      return {
        ...state,
        dayIndex: action.payload
      };
    }
  },
  control
);
